import React, { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MenuChild as MenuChildProps } from '../../../../interfaces/common';

const MenuChild: React.FC<MenuChildProps> = ({ text, redirectsTo }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentRoute = location.pathname;
  const active = Boolean(redirectsTo && currentRoute.includes(redirectsTo));

  const handleMenuChildClick = useCallback(() => {
    if (redirectsTo) {
      navigate(redirectsTo);
    }
  }, [navigate, redirectsTo]);

  return (
    <button
      type="button"
      className={`obs-nav-sub-item ${active ? 'active' : ''}`}
      onClick={handleMenuChildClick}
    >
      {text}
    </button>
  );
};

export default MenuChild;
